// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0px;
  padding: 0px;
}

body {
  height: 100%;
  background-color: #4C5151;
  min-width: 630px;
}

#root {
  height: 100%;
}

div {
  outline-width: 1px;
  outline-color: chartreuse;
  outline-style: dotted;
}`, "",{"version":3,"sources":["webpack://./src/index.scss"],"names":[],"mappings":"AAeA;EACE,WAAA;EACA,YAAA;AAdF;;AAmBA;EACE,YAAA;EACA,yBAAA;EACA,gBAAA;AAhBF;;AAkBA;EACE,YAAA;AAfF;;AAiBA;EACE,kBAAA;EACA,yBAAA;EACA,qBAAA;AAdF","sourcesContent":["// body {\n//   margin: 0;\n//   font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n//     'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n//     sans-serif;\n//   -webkit-font-smoothing: antialiased;\n//   -moz-osx-font-smoothing: grayscale;\n// }\n\n// code {\n//   font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n//     monospace;\n// }\n\n//@use \"style.module\";\n* {\n  margin: 0px;\n  padding: 0px;\n  //height: auto;\n  //box-sizing: border-box;\n  //border: darkred 1px solid;\n}\nbody {\n  height: 100%;\n  background-color: #4C5151;\n  min-width: 630px;\n}\n#root {\n  height: 100%;\n}\ndiv {\n  outline-width: 1px;\n  outline-color: chartreuse;\n  outline-style: dotted;\n}\n//div:nth-child(n) {\n//  background-color: rgb(random(255), random(255), random(255));\n//}\n// div{\n//   background-color: var(--circle-color);\n//     @for $i from 1 through 1000 {\n//       //@debug $i;\n//       &:nth-of-type(#{$i}) {\n//         --circle-color: #{rgb(random(255), random(255), random(255))};\n//       }\n//       //div {\n//       //  background-color: $color;\n//       //}\n//     }\n//     //  @each()\n\n// }\n//div {\n//  background-color: var(--circle-color);\n//  &:nth-child(n) {\n//    --circle-color: #{rgb(random(255), random(255), random(255))};\n//  }\n//}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
